import React from 'react';
import { Clock, Zap, Activity } from 'lucide-react';
const highlights = [{
  icon: Zap,
  title: '1-Week Standard Turnaround',
  subtitle: 'Straightforward cases',
  alt: 'Lightning icon representing rapid 1-week turnaround for standard medico-legal reports'
}, {
  icon: Clock,
  title: '3-Week Complex Case Maximum',
  subtitle: 'Multi-disciplinary & negligence',
  alt: 'Clock icon representing 3-week maximum turnaround for complex medico-legal cases'
}, {
  icon: Activity,
  title: 'Real-Time Case Tracking',
  subtitle: 'From instruction to delivery',
  alt: 'Activity icon representing real-time case tracking for medico-legal report progress'
}];
export function EfficiencyBar() {
  return <section className="bg-[#2D3748] py-12 md:py-16" aria-label="Infographic showing 1-3 week turnaround times for UK medico-legal medical reports" data-id="element-130">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-131">
        {/* Headline */}
        <div className="text-center mb-10" data-id="element-132">
          <h2 className="text-2xl md:text-3xl font-bold text-white tracking-tight mb-3" data-id="element-133">
            Clinical Precision. Accelerated Delivery.
          </h2>
          <p className="text-base text-slate-300 max-w-2xl mx-auto leading-relaxed" data-id="element-134">
            We understand that legal deadlines are non-negotiable. Our
            streamlined triage system ensures reports are delivered within 1 to
            3 weeks, depending on case complexity.
          </p>
        </div>

        {/* 3-column highlights */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-0 md:divide-x md:divide-slate-600" data-id="element-135">
          {highlights.map(item => <div key={item.title} className="flex flex-col items-center text-center px-6 md:px-8" data-id="element-136">
              <div className="w-14 h-14 rounded-xl bg-slate-700 border border-slate-600 flex items-center justify-center mb-4" role="img" aria-label={item.alt} data-id="element-137">
                <item.icon className="h-7 w-7 text-teal-400" aria-hidden="true" data-id="element-138" />
              </div>
              <h3 className="text-lg font-bold text-white mb-1" data-id="element-139">
                {item.title}
              </h3>
              <p className="text-sm text-slate-400" data-id="element-140">{item.subtitle}</p>
            </div>)}
        </div>

        {/* Deadline Guarantee Badge */}
        <div className="flex justify-center mt-10" data-id="element-141">
          <div className="inline-flex items-center gap-3 bg-slate-700/60 border border-slate-600 rounded-full px-6 py-3" data-id="element-142">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#1a2332] to-[#2D3748] border-2 border-slate-400 flex items-center justify-center flex-shrink-0" data-id="element-143">
              <Clock className="h-4 w-4 text-slate-300" data-id="element-144" />
            </div>
            <div className="text-left" data-id="element-145">
              <p className="text-sm font-bold text-white leading-tight" data-id="element-146">
                1–3 Week Delivery Guarantee
              </p>
              <p className="text-xs text-slate-400" data-id="element-147">Court-deadline assured</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}